import { getMultipleCompanies } from './companyTabDetails';
import { createSlice } from "@reduxjs/toolkit";
import authApi from "interceptor/authInterceptor";
import { dispatch, store } from "store";
import toast from "utils/ToastNotistack";
import { get } from "lodash";

const initialState = {
    employers: [],
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0,
    isLoading: false,
};

const employerListData = createSlice({
    name: "employerListData",
    initialState,
    reducers: {
        getEmployers: (state, action) => {
            const { employers, page, pageSize, totalRecords, totalPages } =
                action.payload;
            state.employers = employers;
            state.page = page;
            state.pageSize = pageSize;
            state.totalRecords = totalRecords;
            state.totalPages = totalPages;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        clearemployerListData: () => initialState,
    },
});

export const { getEmployers, setIsLoading, clearemployerListData } =
    employerListData.actions;
export default employerListData.reducer;

export function inviteEmployer(payload: any) {
    return async () => {
        const response = await authApi.post(
            `/v2/api/users/inviteEmployer`,
            payload
        );

        if (response.data) {
            toast("Invited successfully", { variant: "success" });
        }
    };
}

export function getEmployersList(page?: number, pageSize?: number, selectedCompanyId?: string) {
    return async () => {
        const state: any = store.getState();
        const currentPage = page !== undefined && page !== null ? page : (state.employerListData?.page ?? 0);
        const currentPageSize = pageSize !== undefined && pageSize !== null ? pageSize : (state.employerListData?.pageSize ?? 10);

        const currentCompanyId = (selectedCompanyId && selectedCompanyId !== "")
            ? selectedCompanyId
            : (get(state.dashboardSearch, "selectedCompany._id", ""));

        if (!currentCompanyId) {
            console.log("No currentCompanyId found, skipping getEmployersList call");
            return;
        }

        dispatch(setIsLoading(true));
        try {
            const response = await authApi.get(
                `/v2/api/users/getEmployersList?page=${currentPage}&pageSize=${currentPageSize}&companyId=${currentCompanyId}`
            );
            console.log("response", response);
            if (response.data) {
                dispatch(
                    getEmployers({
                        employers: response.data.data.employerList,
                        page: response.data.page,
                        pageSize: response.data.pageSize,
                        totalRecords: response.data.totalCount,
                        totalPages: response.data.totalPages,
                    })
                );
            }
        } catch (error) {
            console.error("Error fetching employers list:", error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }
}

export function changeRole(payload: any, page?: number, rowsPerPage?: number, selectedCompanyId?: string) {
    return async () => {
        const response = await authApi.put(
            `/v2/api/users/updateRole`,
            payload
        );
        if (response.data) {
            toast("Role changed successfully", { variant: "success" });
            dispatch(getEmployersList(page, rowsPerPage, selectedCompanyId))
        }
    };
}

export function assignNewCompany(payload: any) {
    return async () => {
        const response = await authApi.post(
            `/v2/api/users/assignCompany`,
            payload
        );
        if (response.data) {
            toast("Company assigned successfully", { variant: "success" });
            dispatch(getEmployersList())
 dispatch(getMultipleCompanies);
        }
    };
}

export function enable2FA(userId: any) {
    return async () => {
        const response = await authApi.post(`/v2/api/users/enable2FA/${userId}`);
        if (response.data) {
            toast(response.data.message, { variant: "success" });
            dispatch(getEmployersList())
 dispatch(getMultipleCompanies);
        }
    };
}

export function disable2FA(userId: any) {
    return async () => {
        const response = await authApi.post(`/v2/api/users/disable2FA/${userId}`);
        if (response.data) {
            toast(response.data.message, { variant: "success" });
            dispatch(getEmployersList())
 dispatch(getMultipleCompanies);
        }
    };
}
